import { ComboField } from '@components/Fields/ComboField';
import { StringField } from '@components/Fields/StringField';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem, Divider } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { linhaDisponibilidades } from '@model/Linha';
import { EnumOperadora, IComboOperadora } from '@model/Operadora';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { ILinhaFilter } from '@services/LinhaService';
import React from 'react';

export type LinhaFilterProps = {
    filter: IFilter<ILinhaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    operadoraCombo: IComboOperadora
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function LinhaFilter ({filter, isLoading, empresaCombo, operadoraCombo, remetenteWhatsappCombo }: LinhaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <StringField
                        field={filter.fields.ddd}
                        label="DDD"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        inputProps={{
                            maxLength: 2,
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <TelefoneField
                        maskType="cel"
                        field={filter.fields.numeroSemMascara}
                        label="Número"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.whatsappEnvio}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>            

                <GridItem xs={2}>
                    <StringField
                        field={filter.fields.numeroContrato}
                        label="Nº Contrato"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        <Divider />
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.operadoraId}
                        label="Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumOperadora.None}>Todas</MenuItem>
                        <Divider />
                        {
                            operadoraCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={1}>
                    <ComboField
                        field={filter.fields.linhaEmpresa}
                        label="Linha Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todas</MenuItem>
                        <Divider />
                        <MenuItem key={1} value="0">Não</MenuItem>
                        <MenuItem key={2} value="1">Sim</MenuItem>
                    </ComboField>
                </GridItem>            

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.disponibilidade}
                        label="Disponibilidade"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="">Todos</MenuItem>
                        <Divider />
                        {
                            linhaDisponibilidades.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}